import { unsetTextStyleAttribute as e } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
import { useTextBackgroundColorExtensionToolbar as t } from "./use-text-background-color-extension-toolbar.mjs";
import { Extension as n } from "@tiptap/core";
//#region src/extensions/text-background-color-extension/index.ts
var r = n.create({
	name: "backgroundColor",
	addOptions() {
		return { types: ["textStyle"] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { backgroundColor: {
				default: null,
				parseHTML: (e) => e.style.backgroundColor,
				renderHTML: (e) => e.backgroundColor ? { style: `background-color: ${e.backgroundColor}` } : {}
			} }
		}];
	},
	addCommands() {
		return {
			setBackgroundColor: (e) => ({ chain: t }) => t().setMark("textStyle", { backgroundColor: e }).run(),
			unsetBackgroundColor: () => ({ tr: t, state: n, dispatch: r }) => e("backgroundColor", n, t, r)
		};
	}
});
//#endregion
export { r as TextBackgroundColor, t as useTextBackgroundColorExtensionToolbar };
